/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Rights } from './rights';

export const getProfileRights = () => {
  return [Rights.ROLE_PROFIL_COMPANIE, Rights.ROLE_DETALII_COMPANIE, Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN]
}

export const getSignupRights = () => {
  return [
    Rights.ROLE_SIGNUP
  ];
}

export const getContactsRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_DETALII_COMPANIE,
    Rights.ROLE_PROFIL_COMPANIE
  ];
}

export const getSelectItemsAdminRights = () => {
  return [Rights.ROLE_SELECT_ITEMS_ADMIN];
}

export const getCompanyRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_DETALII_COMPANIE
  ];
};

export const getCompanyAllRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_DETALII_COMPANIE,
    Rights.ROLE_PROFIL_COMPANIE

  ];
}

export const getSubscriptionManagementRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SELECT_ITEMS_ADMIN
  ];
}

export const getUserEditRights = () => {
  return [Rights.ROLE_USERS, Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_SP_ADMIN];
}

export const getRoleEditRights = () => {
  return [Rights.ROLE_ROLES, Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_SP_ADMIN];
}

export const getAdminRights = () => {
  return [Rights.ROLE_ADMIN];
}

export const getCompanyAdminRights = () => {
  return [Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_SP_ADMIN];
}
